/** Classic Bless/Curse descriptions include blank lines for printed artwork placement. */
export function digitalCardDescription(kind: string, name: string, description: string): string {
  return kind === 'special' && ['Bless', 'Curse'].includes(name)
    ? description.replace(/\r\n/g, '\n').replace(/\n{3,}/g, '\n\n') : description;
}
